import { Button, Form } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';
import React from 'react';

interface IButtonComponent extends ButtonProps {
    buttontext?: string;
    icon?: React.ReactNode;
    htmlType?: 'button' | 'submit' | 'reset';
    loading?: boolean;
    extramessage?: string;
    type?: 'text' | 'link' | 'ghost' | 'primary' | 'default' | 'dashed' | undefined;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

const ButtonComponent: React.FC<IButtonComponent> = props => {
    const {
        buttontext = 'PRIHLASIT_SE',
        icon,
        htmlType = 'button',
        type = 'primary',
        loading,
        disabled,
        size = 'small',
        extramessage,
        onClick
    } = props;
    return (
        <>
            <Form.Item extra={extramessage ? <Paragraph text={extramessage} className="extramessage-text" /> : null}>
                <Button
                    type={type}
                    size={size}
                    icon={icon}
                    onClick={onClick}
                    htmlType={htmlType}
                    loading={loading}
                    {...props}
                    disabled={disabled}
                >
                    <span
                        style={
                            icon
                                ? {
                                      paddingLeft: 6
                                  }
                                : {}
                        }
                    >
                        <TranslateText>{buttontext}</TranslateText>
                    </span>
                </Button>
            </Form.Item>
            {extramessage && <Paragraph text={extramessage} className="extramessage-text" />}
        </>
    );
};

export default ButtonComponent;
